// Note for Angular2+:
// If decorator directives are needed later for Angular2 + code, Attribute Directives might be a solution
// https://angular.io/guide/attribute-directives

import * as angular from "angular";

let app = angular.module("ecanvasserDirectives", ["group"]);

// Register colocated attribute directives. These must be imported AFTER the
// `ecanvasserDirectives` module has been declared above so their
// `angular.module("ecanvasserDirectives")` getter calls succeed.
require("../components/shared/sortable-header/sortable-header.directive");
app.controller(
    "MainCtrl",
    class MainCtrl {
        private readonly $scope: any;

        constructor($scope: any) {
            this.$scope = $scope;
        }
    }
);

app.factory("focus", ($rootScope: any, $timeout: any) => {
    return (name: any) => {
        $timeout(() => {
            $rootScope.$broadcast("focusOn", name);
        });
    };
});

app.directive("myOnFocus", () => {
    return {
        scope: true,
        restrict: "A",
        link: (scope: any, elem: any, attr: any) => {
            elem.bind("focus", () => {
                if (scope[attr.myOnFocus]) {
                    elem.triggerHandler("click");
                }
            });
            elem.bind("blur", () => (scope[attr.myOnFocus] = true));
        },
    };
});

app.directive("focusOn", () => {
    return (scope: any, elem: any, attr: any) => {
        scope.$on(attr.focusOn, () => elem[0].focus());
    };
});

app.directive("stringToNumber", () => {
    return {
        require: "ngModel",
        link: (scope: any, element: any, attrs: any, ngModel: any) => {
            ngModel.$parsers.push((value?: any) => {
                return value ? "" + value : null;
            });
            ngModel.$formatters.push((value: any) => {
                return parseFloat(value);
            });
        },
    };
});

app.directive("myResize", function ($parse) {
    return {
        link: postLink,
    };
    function postLink(scope, elem, attrs) {
        elem.on("resize", function (e) {
            var rs = $parse(attrs.myResize);
            rs(scope, { $event: e });
            scope.$apply();
        });
    }
});

app.directive("castToInteger", () => {
    return {
        restrict: "A",
        require: "ngModel",
        link: (scope: any, element: any, attrs: any, ngModel: any) => {
            ngModel.$parsers.unshift((value: any) => {
                return parseInt(value, 10);
            });
        },
    };
});

app.directive("castToUnsignedInteger", () => {
    return {
        restrict: "A",
        require: "ngModel",
        link: (scope: any, element: any, attrs: any, ngModel: any) => {
            ngModel.$parsers.unshift((value: any) => {
                let n = parseInt(value, 10);
                return isNaN(n) ? 0 : Math.abs(n);
            });
        },
    };
});

app.directive("autoNext", () => {
    return {
        restrict: "A",
        link: (scope: any, element: any, attr: any, form: any) => {
            let tabindex = parseInt(attr.tabindex);
            let maxLength = parseInt(attr.ngMaxlength);
            element.on("keypress", (e: any): boolean => {
                if (element.val().length > maxLength - 2) {
                    let next = angular
                        .element(document.body)
                        .find("[tabindex=" + (tabindex + 1) + "]");
                    if (next.length > 0) {
                        next.focus();
                        return next.triggerHandler("keypress", {
                            which: e.which,
                        });
                    } else {
                        return false;
                    }
                }
                return true;
            });
        },
    };
});

app.directive("myEnter", () => {
    return (scope: any, element: any, attrs: any) => {
        element.bind("keydown keypress", (event: any) => {
            if (event.which === 13) {
                scope.$apply(() => {
                    scope.$eval(attrs.myEnter);
                });

                event.preventDefault();
            }
        });
    };
});

app.directive("onErrorSrc", () => {
    return {
        link: (scope: any, element: any, attrs: any) => {
            element.bind("error", () => {
                if (attrs.src != attrs.onErrorSrc) {
                    attrs.$set("src", attrs.onErrorSrc);
                    if (attrs.class == "team-user-image") {
                        element.addClass("icon-as-image");
                    }
                }
            });
        },
    };
});

let prevScrollTop: any;
app.directive("whenScrolled", () => {
    return {
        restrict: "A",
        link: (scope: any, elem: any, attrs: any) => {
            // we get a list of elements of size 1 and need the first element
            let raw = elem[0];

            // we load more elements when scrolled past a limit
            elem.bind("scroll", () => {
                if (
                    prevScrollTop &&
                    prevScrollTop !== raw.scrollTop &&
                    raw.scrollTop + raw.offsetHeight + raw.clientHeight / 1.2 >=
                        raw.scrollHeight
                ) {
                    scope.loading = true;

                    // we can give any function which loads more elements into the list
                    scope.$apply(attrs.whenScrolled);
                }
                prevScrollTop = raw.scrollTop;
            });
        },
    };
});

app.directive("focusMe", ($timeout: any, $parse: any) => {
    return {
        link: (scope: any, element: any, attrs: any) => {
            let model = $parse(attrs.focusMe);
            scope.$watch(model, (value: any) => {
                if (value === true) {
                    $timeout(() => {
                        element[0].focus();
                    });
                }
            });
        },
    };
});

app.directive("starRating", () => {
    return {
        restrict: "EA",
        template:
            '<div layout="row" ng-class="{readonly: readonly}">' +
            '  <md-button ng-repeat="star in stars" aria-label="{{$index + 1}} star" class="md-icon-button" ng-disabled="readonly" ng-class="{filled: star.filled}" ng-click="toggle($index)">' +
            '    <md-icon class="notranslate filled-star" ng-if="star.filled">star</md-icon>' +
            '    <md-icon class="notranslate" ng-if="!star.filled">star_border</md-icon>' +
            "  </md-button>" +
            "</ul>",
        scope: {
            ratingValue: "=ngModel",
            max: "=?", // optional (default is 5)
            onRatingSelect: "&?",
            readonly: "=?",
        },
        link: (scope: any) => {
            if (scope.readonly == 0) {
                scope.readonly = false;
            } else if (scope.readonly == 1) {
                scope.readonly = true;
            }

            if (scope.max == undefined) {
                scope.max = 5;
            }

            function updateStars(): void {
                scope.stars = [];
                for (let i = 0; i < scope.max; i++) {
                    scope.stars.push({
                        filled: i < scope.ratingValue,
                    });
                }
            }

            scope.toggle = (index: number): void => {
                if (scope.readonly == undefined || scope.readonly === false) {
                    scope.ratingValue = index + 1;
                    if (!angular.isUndefined(scope.onRatingSelect)) {
                        scope.onRatingSelect({
                            rating: index + 1,
                        });
                    }
                }
            };
            scope.$watch("ratingValue", () => updateStars());
            updateStars();
        },
    };
});
